<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model="form.keyword"
              :placeholder="
                $l('form_label_name_search') ||
                  '物料选项名称/物料选项类型搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              v-if="allow('A')"
              variant="outline-success"
              @click="
                $emit('openEditFormDialog', {
                  type: 'add',
                })
              "
            >
              <b-icon-plus></b-icon-plus>{{ $l("INDEX.btn_add") || "新增" }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: "",
}

export default {
  props: {
    dictData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit("reset")
      }
      this.$emit("query", this.form)
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
